import { Box, Button, Typography } from '@mui/material';
import React, { Fragment, useState } from 'react';
import {
    WHY_IT_MATTERS_LABEL,
    getRequirementLabelPath,
    getWhyItMattersPath,
    hasWhyItMatters,
} from './WhyItMatters.helpers';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Locale from '/b2b/common/components/Locale';
import PropTypes from 'prop-types';
import ResponsiveDialog from '/b2b/common/components/ResponsiveDialog';
import { translationExists } from '/b2b/common/helpers/i18n';

/**
 * Explains the legal reasoning behind a single compliance check. A check's expansion panel otherwise
 * only answers "what failed"; this answers "why we look at all", which is the part a reader can't
 * infer from the results. Rendered at the top of the panel so it reads before the row-level detail.
 */
const WhyItMatters = ({ requirement, sx = {} }) => {
    const [open, setOpen] = useState(false);

    if (!hasWhyItMatters(requirement)) return null;

    const requirementLabelPath = getRequirementLabelPath(requirement);

    return (
        <Fragment>
            <Box display="flex" justifyContent="flex-end" ml="auto" sx={sx}>
                <Button
                    onClick={() => setOpen(true)}
                    size="small"
                    startIcon={<InfoOutlinedIcon />}
                    variant="outlined"
                >
                    <Locale path={WHY_IT_MATTERS_LABEL} />
                </Button>
            </Box>
            <ResponsiveDialog
                fullWidth
                maxWidth="sm"
                onClose={() => setOpen(false)}
                open={open}
                showCloseButton
                sectioned
                // The check's own name, so the explanation stays attributable once the dialog covers
                // the panel it was opened from.
                subtitle={translationExists(requirementLabelPath) ? requirementLabelPath : ''}
                title={WHY_IT_MATTERS_LABEL}
            >
                <Typography color="text.secondary" variant="body1">
                    <Locale path={getWhyItMattersPath(requirement)} />
                </Typography>
            </ResponsiveDialog>
        </Fragment>
    );
};

WhyItMatters.propTypes = {
    requirement: PropTypes.string,
    sx: PropTypes.object,
};

export default WhyItMatters;
